//////
//menu
//////
let fixTop = 0;
const body = document.body;
const menuBtn = document.querySelector('.menu a');
const tHeader = document.querySelector('.hTop');

// スクロール禁止関数
function disableScroll() {
  fixTop = window.scrollY;
  window.addEventListener('scroll', lockScroll, { passive: false });
}

// スクロール解除関数
function enableScroll() {
  window.removeEventListener('scroll', lockScroll, { passive: false });
}

// スクロール位置を固定する処理
function lockScroll() {
  window.scrollTo(0, fixTop);
}

menuBtn.addEventListener('click', function (e) {
  e.preventDefault();

  const isOpen = this.classList.toggle('active');
  body.classList.toggle('side-open', isOpen);

  // ===== header制御用ガード =====
  const canControlHeader =
    tHeader && !tHeader.classList.contains('over');

  if (isOpen) {
    // メニュー OPEN
    disableScroll();

    if (canControlHeader && !tHeader.classList.contains('on')) {
      tHeader.classList.add('on');
    }

  } else {
    // メニュー CLOSE
    enableScroll();

    if (canControlHeader) {
      tHeader.classList.remove('on');
    }
  }
});
